/* styles.ts generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _10 = "._19pkidpf{margin-top:0}";
const _9 = "._zulp1eps{gap:var(--ds-space-100)}";
import { BodyNormal } from '@atlassian/mpac-primitives';
const _8 = "._19bvidpf{padding-left:0}";
const _7 = "._n3tdidpf{padding-bottom:0}";
const _6 = "._u5f3idpf{padding-right:0}";
const _5 = "._ca0qidpf{padding-top:0}";
const _4 = "._qtt8glyw{list-style:none}";
const _3 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
export const ResourceList = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _zulpxy5q _qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ResourceList.displayName = 'ResourceList';
}
export const ResourceListItem = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "li",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _9]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _zulp1eps", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ResourceListItem.displayName = 'ResourceListItem';
}
export const ResourceSubTitle = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_10]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkidpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ResourceSubTitle.displayName = 'ResourceSubTitle';
}